import React from 'react';
import StaticPageLayout from '@/components/StaticPageLayout/StaticPageLayout';
import t from '@/features/allHome/utils/Language/AllHome-translations';

const HelpfulLinks = (props) => {
  const helpfulLinksPage = props.config.pages.helpfullinks;

  return <StaticPageLayout content={helpfulLinksPage} pageLayout={{ left: 6, right: 6 }} t={t}></StaticPageLayout>;
};

export default HelpfulLinks;
